// GEODETIC DATUM
export const GET_GEODETIC_DATUMS = '/geodetic_datum/query';
export const GET_GEODETIC_DATUM = '/geodetic_datum/';
export const POST_GEODETIC_DATUM = '/geodetic_datum/';
export const PUT_GEODETIC_DATUM = '/geodetic_datum/';
export const DELETE_GEODETIC_DATUM = '/geodetic_datum/';
export const CHECK_GEODETIC_DATUM_EXISTS = '/geodetic_datum/query';
